var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$fetchState.pending && _vm.product)?_c('btn',{attrs:{"size":_vm.size},on:{"click":function($event){return _vm.openModal()}}},[_vm._v(_vm._s(_vm.button.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }